import React, { useContext, useEffect } from "react";
import ApplicationInfoMessage from "../../../ApplicationInfo/components/ApplicationInfoMessage";
import { assetIds, ThemedAsset } from "nemuru-components";
import { useTheme } from "@material-ui/core";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";
import { RedirectToMerchantButton } from "../../../../../shared/components/RedirectToMerchantButton";

export const PendingApprovalMessage = () => {
  const { palette } = useTheme();
  const { dispatch } = useContext(ProcessContext);

  useEffect(() => {
    dispatch({
      type: "UPDATE_PROCESS_CONTEXT",
      payload: {
        hideSections: true,
      },
    });
  }, []);

  return (
    <ApplicationInfoMessage
      asset={
        <ThemedAsset
          id={assetIds.ICON_SUCCESS}
          width={50}
          height={50}
          style={{ color: palette.success.main }}
        />
      }
      color={palette.success.main}
      title={"THANKS"}
      subtitle={"APPLICATION_PENDING_APPROVAL"}
      detail={"LOAN_ANALYSING"}
      instructions={{
        title: null,
      }}
      button={<RedirectToMerchantButton />}
    />
  );
};
